// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6417935d","455":"d05f3ff2","977":"a0f3e6fe"}[chunkId] + ".chunk.js";
};